import React, { useEffect, lazy, createElement } from 'react';
import { SEO } from '../components/SEO';
export function PhotographerApplyPage() {
  useEffect(() => {
    // Load Tally embed script
    const script = document.createElement('script');
    script.src = 'https://tally.so/widgets/embed.js';
    script.async = true;
    script.onload = () => {
      if (typeof (window as any).Tally !== 'undefined') {
        ;
        (window as any).Tally.loadEmbeds();
      }
    };
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return <>
      <SEO title="Apply as a Photographer — Aspect" description="Apply to work with Aspect on rights-cleared architectural documentation projects." data-id="element-584" />
      <div className="max-w-3xl mx-auto" data-id="element-585">
        <h1 className="text-3xl md:text-4xl font-medium leading-tight mb-6 text-aspect-black" data-id="element-586">
          Apply as a photographer
        </h1>
        <p className="text-lg text-aspect-black/80 mb-8" data-id="element-587">
          Apply to work with Aspect on rights-cleared architectural
          documentation projects.
        </p>

        <p className="text-sm text-aspect-gray mb-12" data-id="element-588">
          Aspect works with a vetted network of professional architectural
          photographers.
        </p>

        <div className="w-full" style={{
        colorScheme: 'light',
        backgroundColor: '#F6F7F5'
      }} data-id="element-589">
          <iframe data-tally-src="https://tally.so/embed/PdD85x?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1" loading="lazy" width="100%" height="1054" frameBorder="0" marginHeight={0} marginWidth={0} title="Photographer Application" className="w-full" data-id="element-590" />
        </div>
      </div>
    </>;
}